import styled from "styled-components";

export const ProjectViewWrapper = styled.div`
    display: flex;
`;

export const Project = styled.div`  
    line-height: 2;
    padding-left: 8px;
    font-size: 0.875rem;
`;